function containsKeyword(str, keywords) {
    for (let i = 0; i < keywords.length; i++) {
        if (str.includes(keywords[i])) {
            return true;
        }
    }
    return false;
}

export default containsKeyword